import { render, staticRenderFns } from "./IssueReportsManage.vue?vue&type=template&id=f320b492&scoped=true&"
import script from "./IssueReportsManage.vue?vue&type=script&lang=js&"
export * from "./IssueReportsManage.vue?vue&type=script&lang=js&"
import style0 from "./IssueReportsManage.vue?vue&type=style&index=0&id=f320b492&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f320b492",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f320b492')) {
      api.createRecord('f320b492', component.options)
    } else {
      api.reload('f320b492', component.options)
    }
    module.hot.accept("./IssueReportsManage.vue?vue&type=template&id=f320b492&scoped=true&", function () {
      api.rerender('f320b492', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/monbi/system/IssueReportsManage.vue"
export default component.exports